var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-chip"},[_c('sk-chip',{attrs:{"label":_vm.status.text,"color":_vm.status.class}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }